"use client";

import { useState } from "react";
import { ChevronDown, MapPin } from "lucide-react";
import { useAuth } from "@/context/auth-context";
import { useStoreLocation } from "@/context/store-location-context";
import { useFirstDeliverySlot } from "@/hooks/use-first-delivery-slot";
import AuthDialog from "@/components/auth/auth-dialog";
import DeliveryInfoDialog from "./delivery-info-dialog";

export default function NextDeliveryInfo() {
  const [open, setOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  const { storeLocation } = useStoreLocation();
  const address = storeLocation.fullAddressStr ?? "Ingresa tu dirección para ver los horarios de entrega disponibles";
  const firstSlotData = useFirstDeliverySlot(storeLocation.addressId);
  const firstSlot = storeLocation.fullAddressStr ? firstSlotData : null;

  return (
    <>
      <button
        type="button"
        onClick={() => isAuthenticated ? setOpen(true) : setAuthOpen(true)}
        className="flex items-center gap-1 text-left min-w-0 cursor-pointer px-2 py-1 rounded-md hover:bg-accent transition-colors"
      >
        <MapPin className="h-3.5 w-3.5 text-muted-foreground flex-shrink-0" />
        <div className="min-w-0">
          <p className="text-xs font-semibold leading-tight">
            {firstSlot ?? "Siguiente entrega"}
          </p>
          <p className="text-xs text-muted-foreground leading-tight truncate max-w-[180px]">
            {address}
          </p>
        </div>
        <ChevronDown className="h-3.5 w-3.5 text-muted-foreground flex-shrink-0" />
      </button>

      <AuthDialog open={authOpen} onOpenChange={setAuthOpen} onSuccess={() => setOpen(true)} />
      <DeliveryInfoDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
